import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.element.querySelectorAll('.day-selector').forEach(label => {
      label.addEventListener('click', this.toggleDay.bind(this))
    })
  }

  toggleDay(event) {
    const label = event.currentTarget
    const checkbox = label.querySelector('.day-checkbox')
    const dayValue = checkbox.value
    const isCurrentlyChecked = checkbox.checked

    if (!isCurrentlyChecked && this.isAbRulesDay()) {
      if (this.isDaySelectedInOtherExperience(dayValue, checkbox)) {
        event.preventDefault()
        this.showDayConflictWarning(dayValue)
        return
      }
    }

    checkbox.checked = !checkbox.checked

    if (checkbox.checked) {
      label.classList.add('bg-input', 'text-white')
      label.classList.remove('bg-transparent', 'text-input')
    } else {
      label.classList.remove('bg-input', 'text-white')
      label.classList.add('bg-transparent', 'text-input')
    }
  }

  isAbRulesDay() {
    const abRulesController = document.querySelector('[data-controller*="ab-rules"]')
    if (!abRulesController) return false

    const abRulesSelect = abRulesController.querySelector('select[name*="[ab_rules]"]')
    if (!abRulesSelect) return false

    if (abRulesSelect.tomselect) {
      return abRulesSelect.tomselect.getValue() === 'day'
    }

    return abRulesSelect.value === 'day'
  }

  isDaySelectedInOtherExperience(dayValue, currentCheckbox) {
    const currentCheckboxName = currentCheckbox.name
    const currentExperienceMatch = currentCheckboxName.match(/\[(\d+)\]/)
    if (!currentExperienceMatch) return false

    const currentExperienceIndex = currentExperienceMatch[1]

    const allDayCheckboxes = document.querySelectorAll(`input.day-checkbox[value="${dayValue}"]`)
    
    for (const checkbox of allDayCheckboxes) {
      if (checkbox === currentCheckbox) continue
      if (!this.isInVisibleOverlappingCard(checkbox)) continue

      const checkboxName = checkbox.name
      const experienceMatch = checkboxName.match(/\[(\d+)\]/)
      if (!experienceMatch) continue

      const experienceIndex = experienceMatch[1]

      if (experienceIndex !== currentExperienceIndex && checkbox.checked) {
        return true
      }
    }

    return false
  }

  isInVisibleOverlappingCard(element) {
    const card = element.closest('[data-experience-index]')
    if (!card) return true
    return card.style.display !== 'none'
  }

  showDayConflictWarning(dayValue) {
    const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    const dayName = dayNames[dayValue] || `Day ${dayValue}`
    const message = `${dayName} is already selected for another experience. Each day can only be assigned to one experience.`

    const event = new CustomEvent('flash:warning', {
      detail: { message }
    })
    document.dispatchEvent(event)
  }
}

